/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S2_Terminate_TermInputs */

const tr_iade_iptal_s2_terminate_term = /** @type {(inputs: Iade_Iptal_S2_Terminate_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fesih:`)
};

const en_iade_iptal_s2_terminate_term = /** @type {(inputs: Iade_Iptal_S2_Terminate_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termination:`)
};

const de_iade_iptal_s2_terminate_term = /** @type {(inputs: Iade_Iptal_S2_Terminate_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beendigung:`)
};

const ru_iade_iptal_s2_terminate_term = /** @type {(inputs: Iade_Iptal_S2_Terminate_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расторжение:`)
};

/**
* | output |
* | --- |
* | "Termination:" |
*
* @param {Iade_Iptal_S2_Terminate_TermInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s2_terminate_term = /** @type {((inputs?: Iade_Iptal_S2_Terminate_TermInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S2_Terminate_TermInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s2_terminate_term(inputs)
	if (locale === "de") return de_iade_iptal_s2_terminate_term(inputs)
	if (locale === "ru") return ru_iade_iptal_s2_terminate_term(inputs)
	return tr_iade_iptal_s2_terminate_term(inputs)
});